<script>
import AddTutorTask from "@/view/pages/tutor/task-management/add-task-management/AddTutorTask.vue";
import AddOtherTask from "@/view/pages/tutor/task-management/add-task-management/AddOtherTask.vue";

export default {
  name: "AddTaskManagementIndex",
  components: {AddOtherTask, AddTutorTask},
  data() {
    return {
      radio: '',
      size: 'lg',
      taskType: '',
      tutorType: 1,
      otherTaskType: 2
    }
  },
  methods: {
    handleTaskType() {
      this.taskType = this.radio
    },
    resetData(){
      this.radio = ''
      this.size = 'lg'
      this.taskType = ''
    },
    closeModal(isCreateSuccessful) {
      if(isCreateSuccessful){
        this.$emit('loadList')
      }
        this.$bvModal.hide('create-task-tutor')
    }
  },
  computed:{
    title(){
      if(this.taskType === this.otherTaskType){
        return  'Thêm mới tác vụ khác'
      }else if(this.taskType === this.tutorType){
        return 'Đặt lịch gia sư'
      }else {
        return 'Thêm mới tác vụ'
      }
    }
  }
}
</script>

<template>
  <b-modal id="create-task-tutor" :title="title" hide-footer :size="size" @show="resetData()" centered>
    <div v-if="taskType === ''">
      <p class="mb-5 bold" style="font-weight: bold;font-size: 14px">Chọn nhu cầu thêm mới tác vụ</p>
      <el-radio v-model="radio" :label="tutorType" class="mb-5">Đặt lịch gia sư</el-radio>
      <br>
      <el-radio v-model="radio" :label="otherTaskType">Thêm mới tác vụ khác</el-radio>
      <div class="d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-secondary mr-4" @click="closeModal()">Hủy bỏ</button>
        <button type="button" class="btn btn-primary" @click="handleTaskType()">Xác nhận</button>
      </div>
    </div>
    <div v-if="taskType === tutorType">
      <AddTutorTask @closeModal="closeModal" @comeBack="taskType = ''"></AddTutorTask>
    </div>
    <div v-if="taskType === otherTaskType">
      <AddOtherTask @comeBack="taskType = ''" @closeModal="closeModal"></AddOtherTask>
    </div>
  </b-modal>
</template>

<style scoped>

</style>